export default "__VITE_ASSET__DmkYqbvZ__"